import { Box, Grid } from "@mui/material";
import axios from "axios";
import React from "react";
import SaveAltIcon from '@mui/icons-material/SaveAlt';

export const Diseño3 = ({ producto, categoria }) => {
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const handleDescargar = () => {
        if (producto.pdf) {
            const url = `${backendURL}/${producto.pdf}`;
            window.open(url, '_blank');
        }
    };

    const descargar = async () => {
        if (!producto.id) return;

        try {
            const url = `${backendURL}/api/producto/${producto.id}/descargar-pdf`;

            const response = await axios.get(url, {
                responseType: 'blob', // importante para archivos binarios
            });
            handleDescargar();
            // Crear un blob con el tipo correcto
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

            // Crear un enlace para descargar
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(pdfBlob);

            // Nombre del archivo (puedes personalizarlo)
            link.download = 'ficha-tecnica.pdf';

            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error al descargar PDF:', error);
        }
    };
    const caracteristicas = [
        producto.caracteristica,
        producto.caracteristica1,
        producto.caracteristica2,
        producto.caracteristica3,
        producto.caracteristica4,
        producto.caracteristica6,
    ].filter(Boolean);

    const beneficios = [
        producto.beneficio,
        producto.beneficio1,
        producto.beneficio2,
        producto.beneficio3,
        producto.beneficio4,
        producto.beneficio5,
        producto.beneficio6,
    ].filter(Boolean);

    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '4rem'

                }}>
                <h1 className="TituloPaginaProducto">{categoria.titulo}</h1>
                <h1 className="Titulo1PaginaProducto">{categoria.titulo1}</h1>
            </Box>

            <Grid container >
                <Grid size={{ sm: 12, md: 6 }} sx={{

                    display: "flex", alignItems: 'center', justifyContent: 'center', flexDirection: 'column'
                }}>

                    <Box className='ImagenProdcutoPaginaEspecificas'>
                        <div className="imagendiseño2">
                            {producto.imagen_producto && (
                                <img
                                    src={`${backendURL}/${producto.imagen_producto}`}
                                    alt="hod"
                                    title="hod"
                                />
                            )}
                        </div>
                    </Box>




                </Grid>
                <Grid size={{ sm: 12, md: 6 }} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Box>
                             <Box
                                                        sx={{
                                                            display:'flex',
                                                            alignItems:"center",
                                                            justifyContent:"flex-end"
                                                        }}>
                                                               <Box className='ImagenLogoEmpresaMaquinaPaginaEspecificas' sx={{display:"flex",
                                         '@media (max-width:899px)': {
                                    display:"none"
                                },
                                      }}
                                      >
                                                        {producto.logo_empresa_maquina && (
                                                                                            <img
                                                                                                src={`${backendURL}/${producto.logo_empresa_maquina}`}
                                                                                                alt="hod"
                                                                                                title="hod"
                                                                                            />
                                                                                        )}
                                                    </Box>                             
                                                        </Box>
                        {/* informacion producto */}
                        <Box className='infoProductoMaquina'>
                            <Box className='contienetitulomaquinaprodcutopagina'>
                                <h1 className="titulovasos">{producto.titulo_maquina}</h1>
                                <h1 className="titulo1vasos" style={{ color: producto.color || '#1A425B' }}>{producto.nombre_maquina}</h1>
                            </Box>


                            <Box
                                sx={{
                                    width: '70%',
                                    marginTop: '30px',
                                    display: 'flex',
                                    '@media (max-width:600px)': {
                                        width: '100%',
                                    },
                                }}>

                                <Box
                                    sx={{
                                        width: '4px',
                                        backgroundColor: producto.color || '#1A425B',
                                        borderRadius: '4px  4px',
                                        margin: '10px'
                                    }}
                                />
                                <Box className="cardvisionproducto">

                                    <h4>{producto.texto_innovacion}</h4>
                                </Box>


                            </Box>

                        </Box>
                    </Box>
                </Grid>

            </Grid>

            <Box sx={{
                marginTop: '50px'
            }}>
                <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Grid size={{ sm: 12, md: 6 }}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '30px',
                            '@media (max-width:600px)': {
                                flexDirection: 'column'
                            },
                        }}>
                            <div className="figuravaso1">
                                {producto.imagen_dispositivo && (
                                    <img
                                        src={`${backendURL}/${producto.imagen_dispositivo}`}
                                        alt="hod"
                                        title="hod"
                                    />
                                )}
                            </div>
                            <Box sx={{ marginLeft: '20px' }}>
                                <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                                    {caracteristicas.map((item) => (
                                        <li className="descripciondetalladomaquina"  >
                                            <span style={{ color: producto.color || '#1A425B', marginRight: "6px" }}>▶</span>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </Box>
                        </Box>

                    </Grid>

                    <Grid size={{ sm: 12, md: 6 }}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            '@media (max-width:600px)': {
                                flexDirection: 'column'
                            },
                        }}>
                            <div className="figuravaso1">
                                {producto.imagen_dispositivo1 && (
                                    <img
                                        src={`${backendURL}/${producto.imagen_dispositivo1}`}
                                        alt="hod"
                                        title="hod"
                                    />
                                )}
                            </div>
                            <Box sx={{ marginLeft: '20px' }}>
                                <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                                    {beneficios.map((item) => (
                                        <li className="descripciondetalladomaquina"  >
                                            <span style={{ color: producto.color || '#1A425B', marginRight: "6px" }}>▶</span>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </Box>
                        </Box>

                    </Grid>
                </Grid>
            </Box>
            <Box sx={{
                marginTop: '100px'
            }}>
                <div className="tablavasos">
                    {producto.logo_dispositivo && (
                        <img
                            src={`${backendURL}/${producto.logo_dispositivo}`}
                            alt="hod"
                            title="hod"
                        />
                    )}
                </div>
            </Box>
              <Box
      sx={{
        mt:20,
        display:'flex',
        alignItems:'center', 
        justifyContent:'center'
      }}>
{producto.pdf && (
  <button
    onClick={descargar}
    className="anchobotondescarga"
    style={{
      '--boton-color': producto.color || '#1A425B',
    }}
  >
    <SaveAltIcon sx={{ marginRight: '10px', fontSize: '2rem' }} />
    <p style={{ margin: 0 }}>Descargar ficha técnica</p>
  </button>
)}
      </Box>
        </Box>
    )
}